import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';

export default function ExportToolbar(props) {
  const fields = props.columns
    .map((field) => field.field)
    .filter((field) => !['edit', 'select', 'history'].includes(field));
  // console.log("fields:", fields);
  return (
    // GridToolbarContainer is a flexbox by default
    <GridToolbarContainer sx={{ justifyContent: 'flex-end' }}>
      <GridToolbarExport
        csvOptions={{
          fields: fields,
          fileName: `spn-export-${props.termCode}-${props.crn}`,
        }}
      />
    </GridToolbarContainer>
  );
}
